import {Component, OnInit} from '@angular/core';

import {getNavItems} from './_nav';
import {environment} from "../../../environments/environment";
import {UserAccessService} from "../../shared/auth/user-access-service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  standalone: false,
})
export class DefaultLayoutComponent implements OnInit {
  public navItems: any[] = [];
  // La barre latérale est toujours foncée (couleurs CRC) : logo pâle peu importe le thème clair/sombre.
  readonly logo: string = environment.branding.logoDark;

  constructor(private userAccessService: UserAccessService) {}

  ngOnInit(): void {
    this.userAccessService.getUserRoles().subscribe(roles => {
      this.navItems = getNavItems(roles);
    });
  }
}
